import type { VisualEffect } from '../tilemap/types';

export class LineShotEffect implements VisualEffect {
  private elapsed = 0;
  private readonly duration = 0.22;
  private readonly fromX: number;
  private readonly fromY: number;
  private readonly toX: number;
  private readonly toY: number;
  private readonly tileToScreenCenter: (x: number, y: number) => { x: number; y: number };
  private readonly tileSize: number;
  private readonly glowColor: string;
  private readonly coreColor: string;

  constructor(options: {
    fromX: number;
    fromY: number;
    toX: number;
    toY: number;
    tileToScreenCenter: (x: number, y: number) => { x: number; y: number };
    tileSize: number;
    glowColor?: string;
    coreColor?: string;
  }) {
    this.fromX = options.fromX;
    this.fromY = options.fromY;
    this.toX = options.toX;
    this.toY = options.toY;
    this.tileToScreenCenter = options.tileToScreenCenter;
    this.tileSize = options.tileSize;
    this.glowColor = options.glowColor ?? 'rgba(255, 248, 196, 0.25)';
    this.coreColor = options.coreColor ?? 'rgba(255, 214, 102, 0.95)';
  }

  update(deltaSeconds: number): void {
    this.elapsed += deltaSeconds;
  }

  renderOverlay(ctx: CanvasRenderingContext2D): void {
    const progress = Math.min(this.elapsed / this.duration, 1);
    const alpha = 1 - progress;
    const from = this.tileToScreenCenter(this.fromX, this.fromY);
    const to = this.tileToScreenCenter(this.toX, this.toY);
    const currentX = from.x + (to.x - from.x) * progress;
    const currentY = from.y + (to.y - from.y) * progress;

    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.lineCap = 'round';

    ctx.beginPath();
    ctx.lineWidth = this.tileSize * 0.18;
    ctx.strokeStyle = this.glowColor;
    ctx.moveTo(from.x, from.y);
    ctx.lineTo(currentX, currentY);
    ctx.stroke();

    ctx.beginPath();
    ctx.lineWidth = this.tileSize * 0.07;
    ctx.strokeStyle = this.coreColor;
    ctx.moveTo(from.x, from.y);
    ctx.lineTo(currentX, currentY);
    ctx.stroke();
    ctx.restore();
  }

  isComplete(): boolean {
    return this.elapsed >= this.duration;
  }
}
